import React, { useState, useRef } from "react";
import "./PlainHeader.css";
import { BiMenuAltLeft } from "react-icons/bi";
import { IoCloseOutline } from "react-icons/io5";
import { useHistory } from "react-router-dom";
import Contact from "../../pages/Contact/Contact";

const PlainHeader = () => {

    const navMenuRef = useRef(null);

    // listeners

    const navToggleClick = () => {
        navMenuRef.current.classList.toggle('show');
    }

    const closeMenuClick = () => {
        navMenuRef.current.classList.remove('show');
    }

    let history = useHistory();
    const [contactPageStatus, setContactPageStatus] = useState(false);

    const changeRoute = (path) => {
        history.push(path);
    };

    const revealContactPage = () => {
        setContactPageStatus(true);
    };

    return (
        <header className="l-header">
            <nav className="nav bd-grid">
                <div>
                    <span style={{ cursor: "pointer" }} onClick={() => changeRoute('/')} className="navLogo">No Wires</span>
                </div>

                <div className="navToggle" onClick={navToggleClick} id="nav-toggle">
                    <BiMenuAltLeft />
                </div>

                <div className="navMenu" ref={navMenuRef} id="nav-menu">
                    <div className="navClose" onClick={closeMenuClick} id="nav-close">
                        <IoCloseOutline />
                    </div>

                    <ul className="navList">
                        <li className="navItem"><span onClick={() => changeRoute('/')} className="navLink active">Home</span></li>
                        <li className="navItem"><span onClick={() => changeRoute('/about')} className="navLink">About</span></li>
                        <li className="navItem"><span onClick={() => window.open("https://jayanthsaikiran.netlify.app/", "_blank")} className="navLink">Portfolio</span></li>
                        <li className="navItem"><span onClick={() => revealContactPage()} className="navLink">Contact</span></li>
                    </ul>
                </div>
            </nav>
            {contactPageStatus && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Contact closeHandler={() => setContactPageStatus(false)} />
                </div>
            )}
        </header>
    );
};

export default PlainHeader;
